import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { NgSelectModule } from '@ng-select/ng-select';

import { PdfTemplateControlComponent } from './pdf-template-control.component';
import { RnplCommonModule } from 'common/src/modules';

@NgModule({
  declarations: [
    PdfTemplateControlComponent,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    NgSelectModule,
    RnplCommonModule,
    TranslateModule,
  ],
  exports: [
    PdfTemplateControlComponent,
  ],
  entryComponents: [PdfTemplateControlComponent],
})
export class PdfTemplateControlModule { }
